import { createAsyncThunk } from "@reduxjs/toolkit";
import { FE_HOST } from "../constants";

import { getCsrfToken } from "utils";

export const loadWaveformThunk = createAsyncThunk(
  "player/load",
  async (payload, { rejectWithValue }) => {
    const {
      recordingId,
      meta: { waveformUrl },
    } = payload;
    const response = await fetch(
      `${FE_HOST}${waveformUrl}?token=${getCsrfToken()}`
    );

    const data = await response.json();
    if (!response.ok) {
      const error = data.detail;
      return rejectWithValue(error);
    }
    return { recordingId, waveformData: data };
  }
);
